export const initialToggleObj = {
  clinical_obv: false,
  patient_evaluation: false,
  pain: false,
  mental_health: false,
  special: false,
  agreement: false,
  information: false,
};
